export class AuctionLotImageModel {
    Id: number;
    AuctionLotId: number;
    ResourceFolder: string;
    ResourceFilename: string;

    constructor() {
        this.ResourceFolder = "";
        this.ResourceFilename = "";
    }

    get ImageUrl(): string {
        let url = 'https://mw-back-office-content.s3-ap-southeast-2.amazonaws.com/' + this.ResourceFolder + '/' + this.ResourceFilename;
        return url;
    }
}